import { VehicleBuyInType } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_BUY_IN_TYPE_OPTIONS = [
  { id: VehicleBuyInType.Purchase, name: "fab:VehicleBuyInTypePurchase" },
  { id: VehicleBuyInType.TradeIn, name: "fab:VehicleBuyInTypeTradeIn" },
];

export class VehicleBuyInTypeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "type";
  readonly labelSingular = "fab:VehicleBuyInType";
  readonly labelPlural = "fab:VehicleBuyInType";
  readonly placeholder = "fab:SelectVehicleBuyInType";
  readonly searchPlaceholder = "fab:SearchVehicleBuyInType";
  readonly emptyText = "fab:NoVehicleBuyInTypeFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return { options: VEHICLE_BUY_IN_TYPE_OPTIONS, isLoading: false, error: null };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
